// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OUpload .img-uploader {
  display: flex;
  flex-wrap: wrap;
}
.OUpload .preview {
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 10px;
  width: 100%;
}
.OUpload .preview .img-item {
  width: 100px;
  height: 100px;
  position: relative;
}
.OUpload .preview .img-item.sm {
  width: 50px;
  height: 50px;
}
.OUpload .preview .img-item.md {
  width: 100px;
  height: 100px;
}
.OUpload .preview .img-item.lg {
  width: 150px;
  height: 150px;
}
.OUpload .preview .img-item .delete {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #c40505;
  color: #fff;
  padding: 5px;
  border-radius: 50%;
  font-size: 10px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.OUpload .preview .img-item .delete:hover {
  background: #780202;
}
.OUpload .preview .img-item .uploaded {
  position: absolute;
  bottom: 0;
  left: 0;
  background: #4f934c;
  color: #fff;
  padding: 3px 5px;
  border-radius: 0 0 5px 5px;
  font-size: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.OUpload .preview .img-item .failed {
  position: absolute;
  bottom: 0;
  left: 0;
  background: #c40505;
  color: #fff;
  padding: 3px 5px;
  border-radius: 0 0 5px 5px;
  font-size: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.OUpload .preview .img-item .prev {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.OUpload .preview .img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.OUpload .dropzone {
  width: 100%;
  height: 180px;
  border: 2px dashed #e2e2e2;
  background: #f5f5f5;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
}
.OUpload .dropzone.sm {
  font-size: 1rem;
  height: 42px;
}
.OUpload .dropzone.sm button {
  display: none !important;
}
.OUpload .dropzone.sm i {
  font-size: 1.5rem;
}
.OUpload .dropzone.sm p {
  display: none;
}
.OUpload .dropzone input {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.OUpload .dropzone span,
.OUpload .dropzone .flex-col-center {
  font-size: 2rem;
  color: #ccc;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.OUpload .dropzone span.change,
.OUpload .dropzone .flex-col-center.change {
  font-size: 1rem;
}
.OUpload .dropzone2 {
  width: 100px;
  height: 100px;
  border: 1px dashed #1d2088;
  position: relative;
}
.OUpload .dropzone2.sm {
  width: 65px;
  height: 50px;
}
.OUpload .dropzone2.md {
  width: 100px;
  height: 100px;
}
.OUpload .dropzone2.lg {
  width: 150px;
  height: 150px;
}
.OUpload .dropzone2 {
  cursor: pointer;
}
.OUpload .dropzone2:hover {
  border: 1px dashed #000;
  background: #1eb9ee;
}
.OUpload .dropzone2 input {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.OUpload .dropzone2 span {
  font-size: 1rem;
  color: #1d2088;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.OUpload .dropzone2 span.change {
  font-size: 1rem;
}
.OUpload .dropzone2 span.sm {
  font-size: 1rem;
}
.OUpload .upload-btn button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background: #000;
  color: #fff;
  margin-top: 10px;
  cursor: pointer;
}
.OUpload .upload-btn button:hover {
  background: #333;
}

.flex-col-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
  width: 100%;
}
.flex-col-center p {
  font-size: 1.05rem;
  color: #000;
  padding: 0 10px;
  text-align: center;
}
.flex-col-center img {
  width: 40px;
  height: 40px;
}

.outline {
  font-size: 1rem;
}

.upload-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 8px 12px;
  background: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 6px;
  color: #0369a1;
  font-size: 14px;
}
.upload-status i {
  color: #0ea5e9;
}`, "",{"version":3,"sources":["webpack://./src/components/OUpload.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,eAAA;AAFJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EAEA,WAAA;AAHJ;AAII;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAFN;AAGM;EACE,WAAA;EACA,YAAA;AADR;AAGM;EACE,YAAA;EACA,aAAA;AADR;AAGM;EACE,YAAA;EACA,aAAA;AADR;AAGM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AADR;AAEQ;EACE,mBAAA;AAAV;AAGM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAGM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAKE;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAHJ;AAOI;EACE,eAAA;EACA,YAAA;AALN;AAMM;EACE,wBAAA;AAJR;AAMM;EACE,iBAAA;AAJR;AAMM;EACE,aAAA;AAJR;AAOI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AALN;AAOI;;EAEE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AALN;AAMM;;EACE,eAAA;AAHR;AAOE;EACE,YAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;AALJ;AAMI;EACE,WAAA;EACA,YAAA;AAJN;AAMI;EACE,YAAA;EACA,aAAA;AAJN;AAMI;EACE,YAAA;EACA,aAAA;AAJN;AAXE;EAiBE,eAAA;AAHJ;AAII;EACE,uBAAA;EACA,mBAxJY;AAsJlB;AAII;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAFN;AAII;EACE,eAAA;EACA,cAnKU;EAoKV,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AAFN;AAGM;EACE,eAAA;AADR;AAGM;EACE,eAAA;AADR;AAMI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAJN;AAKM;EACE,gBAAA;AAHR;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AALF;AAME;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAJJ;AAME;EACE,WAAA;EACA,YAAA;AAJJ;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAJF;AAME;EACE,cAAA;AAJJ","sourcesContent":["$primary_color: #1d2088;\n$secondary_color: #1eb9ee;\n.OUpload {\n  .img-uploader {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .preview {\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 10px;\n    column-gap: 10px;\n\n    width: 100%;\n    .img-item {\n      width: 100px;\n      height: 100px;\n      position: relative;\n      &.sm {\n        width: 50px;\n        height: 50px;\n      }\n      &.md {\n        width: 100px;\n        height: 100px;\n      }\n      &.lg {\n        width: 150px;\n        height: 150px;\n      }\n      .delete {\n        position: absolute;\n        top: -5px;\n        right: -5px;\n        background: #c40505;\n        color: #fff;\n        padding: 5px;\n        border-radius: 50%;\n        font-size: 10px;\n        width: 25px;\n        height: 25px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        &:hover {\n          background: #780202;\n        }\n      }\n      .uploaded {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        background: #4f934c;\n        color: #fff;\n        padding: 3px 5px;\n        border-radius: 0 0 5px 5px;\n        font-size: 10px;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      .failed {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        background: #c40505;\n        color: #fff;\n        padding: 3px 5px;\n        border-radius: 0 0 5px 5px;\n        font-size: 10px;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      .prev {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n  .dropzone {\n    width: 100%;\n    height: 180px;\n    border: 2px dashed #e2e2e2;\n    background: #f5f5f5;\n    position: relative;\n    cursor: pointer;\n    border-radius: 10px;\n    &:hover {\n      // border: 10px dashed #000;\n    }\n    &.sm {\n      font-size: 1rem;\n      height: 42px;\n      button {\n        display: none !important;\n      }\n      i {\n        font-size: 1.5rem;\n      }\n      p {\n        display: none;\n      }\n    }\n    input {\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      cursor: pointer;\n    }\n    span,\n    .flex-col-center {\n      font-size: 2rem;\n      color: #ccc;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      cursor: pointer;\n      &.change {\n        font-size: 1rem;\n      }\n    }\n  }\n  .dropzone2 {\n    width: 100px;\n    height: 100px;\n    border: 1px dashed $primary_color;\n    position: relative;\n    &.sm {\n      width: 65px;\n      height: 50px;\n    }\n    &.md {\n      width: 100px;\n      height: 100px;\n    }\n    &.lg {\n      width: 150px;\n      height: 150px;\n    }\n    cursor: pointer;\n    &:hover {\n      border: 1px dashed #000;\n      background: $secondary_color;\n    }\n    input {\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      cursor: pointer;\n    }\n    span {\n      font-size: 1rem;\n      color: $primary_color;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      cursor: pointer;\n      &.change {\n        font-size: 1rem;\n      }\n      &.sm {\n        font-size: 1rem;\n      }\n    }\n  }\n  .upload-btn {\n    button {\n      padding: 10px 20px;\n      border: none;\n      border-radius: 5px;\n      background: #000;\n      color: #fff;\n      margin-top: 10px;\n      cursor: pointer;\n      &:hover {\n        background: #333;\n      }\n    }\n  }\n}\n.flex-col-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  row-gap: 10px;\n  width: 100%;\n  p {\n    font-size: 1.05rem;\n    color: #000;\n    padding: 0 10px;\n    text-align: center;\n  }\n  img {\n    width: 40px;\n    height: 40px;\n  }\n}\n.outline {\n  font-size: 1rem;\n}\n\n.upload-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 8px 12px;\n  background: #f0f9ff;\n  border: 1px solid #0ea5e9;\n  border-radius: 6px;\n  color: #0369a1;\n  font-size: 14px;\n\n  i {\n    color: #0ea5e9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
